import React, { Component } from 'react';
import API from '../../api/api';
import { message } from 'antd';
import './login.less';

class Login extends Component {

    state = {
        accessTypeMap: new Map([
            ['1', '/'],
            ['2', '/openInfo'],
            ['3', '/coupon/caissa/orderList'],
            ['4', '/query/userFromCensus'],
            ['5', '/leActivity'],
            ['6', '/leRules'],
            ['7', '/leRules'],
            ['8', '/liveInfoList'],
            ['9', '/liveActivity'],
            ['10', '/sensitiveWords'],
            ['11', '/chatSensitiveWordsList'],
            ['12', '/ThemeFlightShopList'],
            ['13', '/treasureHuntUserRule'],
            ['14', '/coupons/add'],
            ['15', '/winterGamesAnswer'],
            ['16', '/liveDraw'],
            ['17', '/cashManagement/alipayTransfer'],
            ['18', '/music/list'],
            ['19', '/insuranceBroker/brokerList'],
            ['20', '/insuranceBroker/sharonList'],
            ['21', '/coupons/cardList'],
        ]),
        accessType: '',
        errorMes: ''
    }

    componentWillMount() {
        const accessKey = this.getQueryString('accessKey');
        this.setState({ accessType: this.getQueryString('accessType') }, () => {
            this.loginAuthentication({ accessKey: accessKey })
        })
    }
    getQueryString(name) {//解析url
        const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        const urlObj = window.location;
        var r = urlObj.href.indexOf('#') > -1 ? urlObj.hash.split("?")[1].match(reg) : urlObj.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]); return null;
    }
    async loginAuthentication(accessKey) { //登陆接口
        let result = await API.loginAuthentication(accessKey);
        const { accessTypeMap, accessType } = this.state;
        if (!result) return;
        if (result.status === "1") {
            // message.success('登陆成功');

            if (accessTypeMap.get(accessType)) {
                if (accessType == 5) {
                    this.props.history.push(accessTypeMap.get(accessType) + '?activityId=' + this.getQueryString('activityId'))
                } else if (accessType == 7 || accessType == 6) {
                    let url = accessTypeMap.get(accessType) + '?activityId=' + this.getQueryString('activityId') + '&ruleType=' + (accessType == 7 ? 1 : 0)
                    this.props.history.push(url)
                } else {
                    this.props.history.push(accessTypeMap.get(accessType) + window.location.search)
                }
            }
            else {
                this.setState({ errorMes: '跳转链接有误，请联系后端攻城狮' })
            }
            return
        }
        this.setState({ errorMes: '请登录运营管理系统' })
        message.error(result.msg)
    };
    render() {
        const { errorMes } = this.state;
        return (
            <div className="loginPane">
                <p className="text">{errorMes}</p>
            </div>
        )
    }
}

export default Login
